import { CommonModule, Location } from '@angular/common'; 
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FaqServicesComponent } from '../../components/faq-services/faq-services';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { environment } from '../../../environments/environment';
import { support } from '../../../environments/support';
import { types } from '../../../environments/types';

@Component({
    imports: [CommonModule, FormsModule, FaqServicesComponent, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-support',
    styleUrls: ['./support.page.scss'],
    templateUrl: './support.page.html'
})
export class SupportPage implements OnInit {
  appURL: string = environment.appURL;
  supportURL: string = environment.supportURL;
  app: any;
  articles: any=[];
  faqs: any=[];
  showgigs: boolean = true;
  usertypes: any=[];
  resetTypes: any=[];
  selectedType: any = 'platform-etiquette';
  selectedFaq: any;
  tosort: any=[];
  keyword: string = '';

  constructor(
    private location: Location,
    private metaService: Meta,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Help & Support: gigexchange');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'Our help centre is a great place to start.' }
    )
    this.usertypes =  Object.values(types);
    this.getTypes();
    this.getArticles('platform_etiquette', '');
    this.updateMeta();
  }

  async updateMeta() {
    let title = this.selectedType.replace('_',' ');
    this.titleService.setTitle('Help & Support ' + title + ': gigexchange');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'Our help centre is a great place to find ' + title + ' articles & FAQs' }
    )
  }

  // Get all types
  async getTypes() {
    const category = this.route.snapshot.paramMap.get('category');
    if (category) {
      let cat = category.replace('-','_');
      this.selectedType = cat;
    } else {
      this.selectedType = this.usertypes[0].key;
    }
  }

  // Get all articles
  async getArticles(type: string, keywords: string) {
    let self = this;

    let obj = Object.values(support[this.selectedType] as any);

    let objFiltered = obj.filter((item: any) => {
      if (keywords !== '') {
        return item.content.toLowerCase().includes(keywords.toLowerCase()) || 
               item.title.toLowerCase().includes(keywords.toLowerCase());
      } else {
        return true;
      }
    })
    // Sort based from CMS order
    objFiltered.sort((a: any, b: any) => a.order - b.order);
    this.articles = objFiltered;
  }

  // Get tab type id
  getTypeTab(value: string) {
    let type = value.replace('_','-');
    this.location.replaceState('/support/' + type );
    this.selectedType = value;
    this.keyword = '';
    this.updateMeta();
    this.getArticles(value, '');
  }

  // Get select type id
  getTypeSelect(value: string) {
    let type = value.replace('_', '-');
    this.location.replaceState('/support/' + type);
    this.selectedType = value;
    this.keyword = '';
    this.updateMeta();
    this.getArticles(value, '');
  }

  onClickedFaq(value :any) {
    if (this.selectedFaq == value) {
      this.selectedFaq = '';
    } else {
      this.selectedFaq = value;
    }
  }

  // Get type
  supportType(value: string) {
    let type = value.replace('_','-');
    this.router.navigate(['/support/' + type ]);
  }

  // Get detail
  supportDetail(type: string, slug: string) {
    this.router.navigate(['/support/' + type + '/' + slug ]);
  }

  // Get search keyword
  getSearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    this.getArticles(this.selectedType, value.toLowerCase());
  }
}
